import images from "./images";

const portfolio = [
    {
        id: 1,
        image: images.portfolio1,
        title: "Signature Brews",
        details: {
            date: "January 15, 2024",
            client: "Coffee Enthusiasts",
            category: "Crafted Brews",
            duration: "Ongoing",
            location: "Available Nationwide at Our Coffee Shops",
            cost: "Prices vary by cup size and brew style",
            leadBarista: "David Carter"
        },
        paragraphs: [
            "Indulge in our signature coffee blends, carefully curated to provide you with the perfect cup every time. Whether you're craving a smooth espresso, a creamy cappuccino, or a refreshing iced latte, our signature brews are crafted to satisfy every taste.",
            "Our Signature Brews are made from the finest, ethically sourced coffee beans, roasted to perfection to bring out the rich and complex flavors. Whether you're a fan of strong espressos or prefer something milder like a flat white, we offer a wide variety of blends and brewing methods tailored to your taste."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6,
        ],
        challenges: [
            "Sourcing the best quality, sustainably grown beans",
            "Achieving consistent brew strength and flavor extraction",
            "Perfectly balancing espresso shots and milk for creamy lattes"
        ],
        solutions: [
            "Sourcing from ethical coffee farmers and roasters",
            "Precision brewing with state-of-the-art espresso machines",
            "Expert barista techniques for smooth, rich textures"
        ],
        results: [
            "A rich, flavorful coffee experience with every sip",
            "Consistency in quality and taste, no matter the cup",
            "A variety of options to suit your preferences, from espresso shots to frothy cappuccinos"
        ],
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Outdoor Seating",
        details: {
            date: "January 15, 2024",
            client: "Cityscapes Designs",
            category: "Inviting Space",
            duration: "Ongoing",
            location: "Available Nationwide at Our Urban Spaces",
            cost: "Prices vary based on size and custom features",
            leadArchitect: "David Carter"
        },
        paragraphs: [
            "Step into a relaxing environment with our carefully designed outdoor seating spaces, perfect for enjoying the fresh air in style. Whether you're looking for a quiet corner to unwind or a vibrant area to socialize, our seating solutions are tailored to meet your needs.",
            "Crafted from durable, weather-resistant materials, each seating arrangement is designed to withstand the elements while providing comfort and elegance. From modern lounge chairs to rustic picnic tables, we offer a range of options to enhance any outdoor setting."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6,
        ],
        challenges: [
            "Designing for various weather conditions and climates",
            "Maximizing space while ensuring comfort",
            "Incorporating sustainable, eco-friendly materials"
        ],
        solutions: [
            "Using weather-resistant, long-lasting materials for durability",
            "Space optimization with modular, flexible seating arrangements",
            "Sourcing eco-friendly materials that blend with nature"
        ],
        results: [
            "An inviting, comfortable outdoor space that encourages relaxation and socializing",
            "Durable seating solutions that stand up to the elements and look great",
            "A harmonious blend of style and function, perfect for any outdoor setting"
        ],
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Latte Art",
        details: {
            date: "January 15, 2024",
            client: "Artisan Coffee Studio",
            category: "Crafted Brews",
            duration: "Ongoing",
            location: "Available Nationwide at Our Coffee Shops",
            cost: "Prices vary by cup size and brew style",
            leadBarista: "David Carter"
        },
        paragraphs: [
            "Experience the artistry of handcrafted brews and latte art, where each cup is a masterpiece. From velvety lattes to perfectly brewed espressos, every drink is meticulously crafted to deliver an exceptional coffee experience.",
            "Our talented baristas use the finest, ethically sourced beans to create stunning latte art. Whether you're enjoying a classic cappuccino or a custom-designed latte, the beautiful patterns are as enjoyable to look at as they are to drink."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6,
        ],
        challenges: [
            "Perfecting intricate latte art designs with precision",
            "Maintaining consistency in brew quality and texture",
            "Balancing artistry with flavor for the perfect coffee"
        ],
        solutions: [
            "Training baristas in advanced latte art techniques",
            "Using high-quality, fresh beans to enhance flavor and texture",
            "Investing in precision espresso machines for flawless brews"
        ],
        results: [
            "A visually stunning and flavorful coffee experience with every cup",
            "Consistent, high-quality brews that look as good as they taste",
            "A wide variety of latte art options that make each cup unique"
        ],
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "Local Events",
        details: {
            date: "January 15, 2024",
            client: "Neighborhood Coffee Collective",
            category: "Community Vibe",
            duration: "Ongoing",
            location: "Available at Various Local Venues",
            cost: "Event pricing varies based on location and size",
            leadCoordinator: "David Carter"
        },
        paragraphs: [
            "At Neighborhood Coffee Collective, we create a strong community vibe by hosting local events that bring people together. From coffee tasting nights to barista workshops, we’re committed to fostering connections through the love of coffee and shared experiences.",
            "Our events are designed to celebrate local culture, support small businesses, and provide opportunities for people to connect over their favorite brews. Whether you're a coffee aficionado or a casual drinker, there's always something for everyone in our community."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio41Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6,
        ],
        challenges: [
            "Engaging the local community and attracting attendees",
            "Managing event logistics and ensuring smooth execution",
            "Creating memorable experiences that resonate with guests"
        ],
        solutions: [
            "Partnering with local vendors and artists to enhance event appeal",
            "Using efficient event planning tools and dedicated staff to ensure seamless operations",
            "Designing interactive, fun, and educational activities for all attendees"
        ],
        results: [
            "A vibrant community atmosphere where people connect and share their passion for coffee",
            "Successful local events that boost brand awareness and support the local economy",
            "An inclusive environment that brings people together to celebrate local culture and coffee"
        ],
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Interior Design",
        details: {
            date: "January 15, 2024",
            client: "Urban Interiors",
            category: "Inviting Space",
            duration: "Ongoing",
            location: "Available Nationwide at Our Coffee Shops",
            cost: "Prices vary based on custom design features and space size",
            leadDesigner: "David Carter"
        },
        paragraphs: [
            "Transform your coffee experience with an inviting space designed to complement our signature brews. Our interior designs focus on creating a warm, welcoming atmosphere that enhances the overall coffee experience. Whether it’s cozy seating, natural lighting, or functional layouts, we design spaces that make you feel at home.",
            "From modern minimalist to rustic charm, our interior designs cater to diverse tastes while maintaining comfort and style. Every detail is thoughtfully curated to foster a relaxed environment, perfect for enjoying your coffee or engaging with friends."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6,
        ],
        challenges: [
            "Designing a space that balances aesthetics and functionality",
            "Maximizing comfort while ensuring an efficient flow of movement",
            "Incorporating elements that create a memorable atmosphere"
        ],
        solutions: [
            "Combining comfort-focused furniture with stylish décor for a balanced look",
            "Utilizing layout designs that ensure seamless customer flow and comfort",
            "Incorporating natural elements like plants, wood, and warm lighting to enhance ambiance"
        ],
        results: [
            "A beautiful, comfortable environment that invites guests to relax and enjoy their coffee",
            "An interior design that blends style, function, and atmosphere to create a unique space",
            "A well-designed coffee shop that encourages both social interaction and personal moments"
        ],
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Workshops Offered",
        details: {
            date: "January 15, 2024",
            client: "Neighborhood Coffee Collective",
            category: "Community Vibe",
            duration: "Ongoing",
            location: "Available at Various Local Venues",
            cost: "Workshop pricing varies based on content and duration",
            leadCoordinator: "David Carter"
        },
        paragraphs: [
            "At Neighborhood Coffee Collective, we foster a strong community vibe by offering a variety of workshops designed to engage coffee lovers and enthusiasts alike. Our workshops are perfect for anyone interested in learning more about coffee, from the art of brewing to mastering latte designs.",
            "Our workshops provide hands-on experience and expert guidance in a friendly and collaborative environment. Whether you’re looking to improve your brewing technique, explore coffee bean origins, or create beautiful latte art, we offer something for every level of interest."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6,
        ],
        challenges: [
            "Attracting a diverse group of participants with varying interests",
            "Ensuring a valuable learning experience for participants of all skill levels",
            "Managing logistics and resources for interactive, hands-on workshops"
        ],
        solutions: [
            "Offering a range of workshop topics to appeal to both beginners and advanced enthusiasts",
            "Providing expert instructors who can tailor their lessons to different experience levels",
            "Using effective planning and coordination to ensure smooth workshop execution and participant satisfaction"
        ],
        results: [
            "A vibrant community where people learn, share, and connect over their love of coffee",
            "Workshops that provide valuable skills and knowledge, enhancing participants' coffee experiences",
            "A strong following of engaged, enthusiastic coffee lovers who return for more learning opportunities"
        ],
    }
];

export default portfolio;